import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/home/vsts/work/1/s/apps/website/src/app/(frontend)/[locale]/(user)/(auth)/forgot-password/forgotPasswordForm.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InputField"] */ "/home/vsts/work/1/s/apps/website/src/components/form/inputField.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationsProvider"] */ "/home/vsts/work/1/s/apps/website/src/modules/localization/translations.client.tsx");
